import DefaultPage from "../DefaultPage";

function AboutApp() {
    return <DefaultPage>
        <div>Welcome to Portfolio page!</div>
    </DefaultPage>
}

export default AboutApp